import React, { useEffect } from "react";
import { Typography, Stack } from "@mui/material";
import { useGetMyProfileQuery } from "../../../../services/ProfileService";
import { useAppDispatch, useAppSelector } from '../../../../app/hooks';
import { setSelectedCenter } from '../../../../services/ConfigurationService';
import { useIsAuthenticated } from "@azure/msal-react";

export interface CenterOption {
    code: string;
    name: string;
}

export const EditableLocationLabel: React.FC = () => {
    const isAuthenticated = useIsAuthenticated();
    const dispatch = useAppDispatch();
    const selectedCenter = useAppSelector(state => state.center.selectedCenter);
    const { data: profile } = useGetMyProfileQuery(undefined, { skip: !isAuthenticated });
    const centers: CenterOption[] = profile?.centerAccess?.map((c: any) => ({ code: c.code, name: c.name })) || [];
    
    useEffect(() => {
        if (centers.length && !centers.find(c => c.code === selectedCenter)) {
            dispatch(setSelectedCenter(centers[0].code));
        }
    }, [centers, selectedCenter, dispatch]);
    
    const selected = centers.find(c => c.code === selectedCenter);

    // Don't render anything when not authenticated
    if (!isAuthenticated) {
        return null;
    }

    return (
        <Stack direction='row' gap={1} alignItems='center'>
            <Typography variant='h6' sx={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{selected?.name || ''}</Typography>
        </Stack>
    );
};
